import { EnumPermissionTypeNone } from "../enums/EnumPermissionTypeNone";
import { FolderInformation } from "../model/ItemModel";
import { KeydrivePlan } from "../model/UserModel";

export interface VisibilityParams {
  organization: string;
  workspace: string;
  isAdminOrg: boolean;
  adminSystem: boolean;
  keydrivePlan: KeydrivePlan;
  folderInfo: FolderInformation;
  loadingFolderInfo: boolean;
  profile: any;
  isGuest: boolean;
}

export const hasOrganization = (organization: string): boolean => {
  return organization !== "";
};

export const hasWorkspace = (workspace: string): boolean => {
  return workspace !== "";
};

export const isAdmin = (isAdminOrg: boolean, adminSystem: boolean): boolean => {
  return isAdminOrg || adminSystem;
};

export const canViewShared = (organization: string): boolean => {
  return hasOrganization(organization);
}

export const canViewDocuments = (organization: string, workspace: string): boolean => {
  return hasOrganization(organization) && hasWorkspace(workspace)
}

export function UserHasLowerPermission(permission: number): boolean {
    return (permission != EnumPermissionTypeNone.none && permission != EnumPermissionTypeNone.commonUser) &&
            permission != EnumPermissionTypeNone.read;
}

export function HasAdminPermission(isAdminOrg: boolean, isAdminSystem: boolean): boolean {
    return isAdminOrg || isAdminSystem;
}

export function UserHasFreePlan(plan: KeydrivePlan): boolean {
    return plan == KeydrivePlan.FREE;
}

export const canViewOrganizationAdvancedFeatures = (params: VisibilityParams): boolean => {
  return !params.isGuest;
}

export const canViewFeed = (params: VisibilityParams): boolean => {

  if (params.isGuest) return false;

  if (UserHasFreePlan(params.keydrivePlan)) return false;

  if (!HasAdminPermission(params.isAdminOrg, params.adminSystem)) return false;

  return true;
};

export const canViewRecycleBin = (params: VisibilityParams): boolean => {
  
  if (params?.isGuest) return false;

  if (UserHasFreePlan(params.keydrivePlan)) return false;

  if (!HasAdminPermission(params.isAdminOrg, params.adminSystem)) return false;

  return true;
};

export const canViewAdvancedWorkspaceFeatures = (params: VisibilityParams): boolean => {
  if (!hasWorkspace(params.workspace)) return false;
  if (params.loadingFolderInfo) return false;
  
  const hasProperPermission = 
    params.folderInfo.permissionType !== EnumPermissionTypeNone.commonUser &&
    params.folderInfo.permissionType !== EnumPermissionTypeNone.read &&
    !params.isGuest;
  
  const isNotFreePlan = params.keydrivePlan !== KeydrivePlan.FREE;

  if (params.adminSystem) {
    return true;
  }
  
  return hasProperPermission && isNotFreePlan;
};

export const canViewPrivileges = (params: VisibilityParams): boolean => {
  if (!hasWorkspace(params.workspace)) return false;
  if (params.loadingFolderInfo) return false;
  
  return canViewAdvancedWorkspaceFeatures(params);
};

export const canViewAdminSection = (organization: string, isAdminOrg: boolean, adminSystem: boolean): boolean => {
  return hasOrganization(organization) && isAdmin(isAdminOrg, adminSystem);
};